/* ============================================================
   BERNITURE MAIN JS
   ============================================================ */

(function () {
  'use strict';

  /* ── HEADER SCROLL ── */
  const header = document.querySelector('.brn-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── MOBILE MENU ── */
  const mobileMenu    = document.getElementById('brn-mobile-menu');
  const menuOpenBtn   = document.getElementById('brn-menu-open');
  const menuCloseBtn  = document.getElementById('brn-menu-close');
  const menuOverlay   = mobileMenu?.querySelector('.brn-mobile-menu__overlay');

  function openMobileMenu() {
    mobileMenu?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    mobileMenu?.classList.remove('open');
    document.body.style.overflow = '';
  }

  menuOpenBtn?.addEventListener('click', openMobileMenu);
  menuCloseBtn?.addEventListener('click', closeMobileMenu);
  menuOverlay?.addEventListener('click', closeMobileMenu);

  /* ── CART DRAWER ── */
  const cartDrawer    = document.getElementById('brn-cart-drawer');
  const cartOverlay   = cartDrawer?.querySelector('.brn-cart-drawer__overlay');
  const cartCloseBtn  = document.getElementById('brn-cart-close');
  const cartTriggers  = document.querySelectorAll('[data-cart-trigger]');

  function openCartDrawer() {
    cartDrawer?.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCartDrawer() {
    cartDrawer?.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(btn => btn.addEventListener('click', openCartDrawer));
  cartCloseBtn?.addEventListener('click', closeCartDrawer);
  cartOverlay?.addEventListener('click', closeCartDrawer);

  /* ── CART FETCH ── */
  function fetchCart() {
    return fetch((window.Shopify?.routes?.root || '/') + 'cart.js')
      .then(r => r.json())
      .then(cart => { updateCartUI(cart); return cart; })
      .catch(console.error);
  }

  function updateCartUI(cart) {
    const countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    const itemsContainer = document.getElementById('brn-cart-items');
    const subtotalEl     = document.getElementById('brn-cart-subtotal');

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = `<div class="brn-cart-empty">
        <p>${itemsContainer.dataset.emptyText || 'Your cart is empty'}</p>
      </div>`;
      return;
    }

    itemsContainer.innerHTML = cart.items.map(item => {
      const visibleProps = Object.entries(item.properties || {})
        .filter(([k, v]) => k && !k.startsWith('_') && v !== null && v !== '');
      const variantLine = visibleProps.length
        ? `<div class="brn-cart-item__variant">${visibleProps.map(([k, v]) => `<span>${k}: ${v}</span>`).join(' ')}</div>`
        : (item.variant_title && item.variant_title !== 'Default Title'
            ? `<div class="brn-cart-item__variant">${item.variant_title}</div>` : '');
      return `
      <div class="brn-cart-item" data-key="${item.key}">
        <div class="brn-cart-item__img">
          <img src="${item.image ? item.image.replace('.jpg', '_120x.jpg') : ''}"
               alt="${item.product_title}" width="80" height="80"
               loading="lazy" style="object-fit:cover;width:80px;height:80px;border-radius:4px;" />
        </div>
        <div class="brn-cart-item__info">
          <div class="brn-cart-item__name">${item.product_title}</div>
          ${variantLine}
          <div class="brn-cart-item__price-row">
            <span class="brn-cart-item__price">${formatMoney(item.final_line_price)}</span>
            <div class="brn-cart-item__qty-wrap">
              <button class="brn-cart-item__qty-btn" data-action="decrease" data-key="${item.key}">−</button>
              <span class="brn-cart-item__qty">${item.quantity}</span>
              <button class="brn-cart-item__qty-btn" data-action="increase" data-key="${item.key}">+</button>
            </div>
          </div>
        </div>
        <button class="brn-cart-item__remove" data-key="${item.key}" aria-label="Remove">×</button>
      </div>
    `;
    }).join('');
  }

  let cartMutationInFlight = false;

  function setCartMutationState(isBusy) {
    const container = document.getElementById('brn-cart-items');
    if (!container) return;

    container
      .querySelectorAll('.brn-cart-item__qty-btn, .brn-cart-item__remove')
      .forEach(btn => {
        btn.disabled = isBusy;
        btn.style.pointerEvents = isBusy ? 'none' : '';
        btn.style.opacity = isBusy ? '0.5' : '';
      });
  }

  // Delegated handler:
  // works for both the server-rendered cart and every AJAX re-render.
  document.addEventListener('click', e => {
    const qtyBtn = e.target.closest(
      '#brn-cart-items .brn-cart-item__qty-btn'
    );

    const removeBtn = e.target.closest(
      '#brn-cart-items .brn-cart-item__remove'
    );

    if (!qtyBtn && !removeBtn) return;

    e.preventDefault();

    // Prevent rapid overlapping Shopify cart mutations.
    if (cartMutationInFlight) return;

    if (removeBtn) {
      const key = removeBtn.dataset.key;
      if (key) updateCartItem(key, 0);
      return;
    }

    const key = qtyBtn.dataset.key;
    const action = qtyBtn.dataset.action;

    const qtyEl = qtyBtn
      .closest('.brn-cart-item__qty-wrap')
      ?.querySelector('.brn-cart-item__qty');

    if (!key || !qtyEl) return;

    const current = parseInt(qtyEl.textContent, 10) || 0;

    const newQty =
      action === 'increase'
        ? current + 1
        : Math.max(0, current - 1);

    updateCartItem(key, newQty);
  });

  async function updateCartItem(key, qty) {
    if (!key || cartMutationInFlight) return;

    cartMutationInFlight = true;
    setCartMutationState(true);

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: qty
        })
      });

      const cart = await response.json();

      if (!response.ok) {
        throw new Error(
          cart.description ||
          cart.message ||
          'Cart quantity update failed'
        );
      }

      // Shopify response is authoritative.
      updateCartUI(cart);

    } catch (error) {
      console.error('Berniture cart mutation failed:', error);

      // Restore UI from Shopify if anything went wrong.
      try {
        await fetchCart();
      } catch (syncError) {
        console.error('Berniture cart resync failed:', syncError);
      }

    } finally {
      cartMutationInFlight = false;
      setCartMutationState(false);
    }
  }


  /* ── ADD TO CART ── */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();

    const variantId = btn.dataset.addToCart;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = btn.dataset.loadingText || '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(r => r.json())
      .then(() => {
        btn.textContent = btn.dataset.addedText || '✓';
        fetchCart();
        setTimeout(() => openCartDrawer(), 300);
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  });

  /* ── SEARCH OVERLAY ── */
  const searchOverlay  = document.getElementById('brn-search');
  const searchInput    = document.getElementById('brn-search-input');
  const searchCloseBtns = document.querySelectorAll('[data-search-close]');
  const searchTriggers  = document.querySelectorAll('[data-search-trigger]');

  function openSearch() {
    searchOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput?.focus(), 100);
  }
  function closeSearch() {
    searchOverlay?.classList.remove('open');
    document.body.style.overflow = '';
  }

  searchTriggers.forEach(btn => btn.addEventListener('click', openSearch));
  searchCloseBtns.forEach(btn => btn.addEventListener('click', closeSearch));

  let searchTimeout;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimeout);
    const q = searchInput.value.trim();
    if (q.length < 2) return;
    searchTimeout = setTimeout(() => predictiveSearch(q), 300);
  });

  function predictiveSearch(q) {
    const grid = document.getElementById('brn-search-results');
    if (!grid) return;
    grid.innerHTML = '<div class="brn-skeleton" style="height:160px;width:100%;border-radius:4px;"></div>'.repeat(4);

    fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`)
      .then(r => r.json())
      .then(data => {
        const products = data.resources?.results?.products || [];
        if (!products.length) {
          grid.innerHTML = `<p style="color:var(--muted);font-size:13px;">No results for "${q}"</p>`;
          return;
        }
        grid.innerHTML = products.map(p => `
          <a href="${p.url}" class="brn-search-result-card">
            <div class="brn-img-wrap brn-img-wrap--square" style="border-radius:4px;overflow:hidden;margin-bottom:8px;">
              <img src="${p.featured_image?.url?.replace('.jpg', '_300x.jpg') || ''}"
                   alt="${p.title}" loading="lazy" />
            </div>
            <div style="font-size:12px;color:var(--ink);margin-bottom:3px;">${p.title}</div>
            <div style="font-size:11px;color:var(--gold);">${p.price}</div>
          </a>
        `).join('');
      })
      .catch(console.error);
  }

  /* ── UTILITY ── */
  function formatMoney(cents) {
    // Matches the store's money format (Settings → General → Currency
    // formatting: "EGP {{amount}}") so AJAX-updated prices (cart drawer,
    // add-to-cart) look identical to the server-rendered ones instead of
    // dropping decimals. The Arabic digit/currency conversion script in
    // theme.liquid re-processes these nodes afterward on /ar/.
    return 'EGP ' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  /* ── LAZY LOAD ── */
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const img = e.target;
          if (img.dataset.src) { img.src = img.dataset.src; }
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    lazyImages.forEach(img => observer.observe(img));
  }

  /* ── ANNOUNCE BAR CLOSE ── */
  const announceClose = document.getElementById('brn-announce-close');
  const announceBar   = document.getElementById('brn-announce');
  announceClose?.addEventListener('click', () => {
    announceBar?.remove();
    sessionStorage.setItem('brn_announce_closed', '1');
  });
  if (sessionStorage.getItem('brn_announce_closed')) {
    announceBar?.remove();
  }

  /* ── ESCAPE KEY ── */
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    closeMobileMenu();
    closeCartDrawer();
    closeSearch();
  });

  /* ── SCROLL TO TOP ── */
  const scrollTopBtn = document.getElementById('brn-scroll-top');
  if (scrollTopBtn) {
    window.addEventListener('scroll', () => {
      scrollTopBtn.style.opacity = window.scrollY > 400 ? '1' : '0';
      scrollTopBtn.style.pointerEvents = window.scrollY > 400 ? 'auto' : 'none';
    }, { passive: true });
    scrollTopBtn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  /* ── CART STYLE ── */
  const cartStyle = document.createElement('style');
  cartStyle.textContent = `
    .brn-cart-item { display:flex; gap:12px; padding:16px 0; border-bottom:1px solid var(--border); }
    .brn-cart-item__info { flex:1; min-width:0; }
    .brn-cart-item__name { font-size:12px; color:var(--ink); margin-bottom:4px; line-height:1.4; }
    .brn-cart-item__variant { font-size:11px; color:var(--muted); margin-bottom:8px; }
    .brn-cart-item__price-row { display:flex; align-items:center; justify-content:space-between; gap:8px; flex-wrap:wrap; }
    .brn-cart-item__price { font-size:12px; color:var(--gold); font-weight:500; }
    .brn-cart-item__qty-wrap { display:flex; align-items:center; gap:8px; }
    .brn-cart-item__qty-btn { width:24px; height:24px; border:1px solid var(--border); border-radius:2px; display:flex; align-items:center; justify-content:center; font-size:14px; color:var(--ink); background:var(--surface); transition:background 0.2s; }
    .brn-cart-item__qty-btn:hover { background:var(--surface-2); }
    .brn-cart-item__qty { font-size:12px; min-width:16px; text-align:center; }
    .brn-cart-item__remove { width:20px; height:20px; display:flex; align-items:center; justify-content:center; font-size:18px; color:var(--muted); transition:color 0.2s; flex-shrink:0; }
    .brn-cart-item__remove:hover { color:var(--error); }
    .brn-cart-empty { text-align:center; padding:40px 20px; font-size:13px; color:var(--muted); }
    .brn-search-results-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(150px,1fr)); gap:16px; }
    .brn-search-result-card { display:block; transition:opacity 0.2s; }
    .brn-search-result-card:hover { opacity:0.8; }
  `;
  document.head.appendChild(cartStyle);

  window.BRNCart = {
    fetchCart: fetchCart,
    openCartDrawer: openCartDrawer,
    closeCartDrawer: closeCartDrawer,
    updateCartItem: updateCartItem,
  };

})();
